export enum UserState {
  SUSPENDED = '0',
  ACTIVE = '1',
}

export enum ValidateEntity {
  CANNOT = '0',
  CAN = '1',
}

export enum SubRoleManipulate {
  CANNOT = '0',
  CAN = '1',
}

export enum GHGInventoryManipulate {
  CANNOT = '0',
  CAN = '1',
}
